export enum ButtonClicked {
  SolutionClicked = 'solution_clicked',
  SolutionDeepLink = 'article_internal_link',
  SolutionLinkInternal = 'Solution Link Internal',
  ArticleLink = 'article_link',
  ArticleCta = 'article_cta',
  Back = 'back',
  OpenArticleInHC = 'open_in_help_center',
  RecommendedArticle = 'recommended_article',
  ExpandArticleSection = 'article_section_expend',
  CollapseArticleSection = 'article_section_collapse',
  ArticleExternalLink = 'article_external_link',
  OpenInNewTab = 'open_in_new_tab',
  ArticleTabSelection = 'tab_selection',
  ArticleInternalAnchor = 'article_internal_anchor',
  ArticleImage = 'article_image',
  CategorySelection = 'category_selection',
  SubCategorySelection = 'sub_category_selection',
  SearchBarTextTyping = 'search_bar_text_typing',
  SearchButtonClicked = 'search_button_clicked',
  ClearSearchBar = 'clear_search_bar',
  HelpCenter = 'help_center',
  HomeResourcesWixLearn = 'home_resources_wix_learn',
  HomeResourcesWixBlog = 'wix_blog',
  HomeResourcesSeo = 'seo_learning_hub',
  HomeResourcesVelo = 'home_resources_velo_hub',
  HomeResourcesPartners = 'home_resources_partners_forum',
  HomeResourcesCustomerCareTickets = 'customer_care_tickets',
  HomeResourcesHireProfessional = 'hire_another_professional',
  HomeResourcesCommunityForum = 'home_resources_community_forum',
  HomeResourcesCommunityForumStudio = 'studio_community',
  HomeResourcesWixDevelopers = 'home_resources_wix_developers',
  HomeResourcesWixDeveloperDocs = 'wix_developer_docs',
  HomeResourcesWixDeveloperCommunity = 'home_resources_developer_community',
  HomeResourcesChatWithUs = 'home_resources_chat_with_us',
  HomeResourcesVideoTutorials = 'video_tutorials',
  HomeResourcesKeyboardShortcuts = 'keyboard_shortcuts',
  HomeResourcesWixStatusPage = 'home_resources_wix_status_page',
  HomeResourcesReportABug = 'home_resources_report_a_bug',
  HomeResourcesWixAppsAssistant = 'home_resources_wix_apps_assistant',
  HirePartner = 'hire_a_professional',
  ContactUs = 'contact_us',
  ChatWithUs = 'chatbot',
  StatusPage = 'status_page',
  StatusBanner = 'status_banner',
  TermsOfUse = 'terms_of_use',
  PrivacyPolicy = 'privacy_policy',
  Breadcrumbs = 'breadcrumbs',
  CloseKbWidget = 'close_kb_widget',
  Notifications = 'chatbot_notifications',
  WidgetCollapse = 'widget_collapse',
  WidgetMaximize = 'widget_maximize',
  WidgetMinimize = 'widget_minimize',
  ContactPartnerSuccessTeam = 'contact_the_partner_success_team',
  RequestFeature = 'request_a_feature',
  ReportBug = 'report_a_bug',
  FeatureRequestVote = 'feature_request_vote',
  FeatureRequestUnvote = 'feature_request_unvote',
  FeatureRequestFollow = 'feature_request_follow',
  FeatureRequestUnfollow = 'feature_request_unfollow',
  KnownIssueVote = 'known_issue_vote',
  KnownIssueUnvote = 'known_issue_unvote',
  SearchResultCategoryButton = 'search_result_category_button',
  SearchSuggestedQuestion = 'search_suggested_question',
  SearchTryDifferent = 'try_a_different_search',
  AnswerGenSummarizedAnsLink = 'summarized_answer_hyperlink',
  AnswerGenSummarizedAnsBasedArticle = 'summarized_answer_based_article',
  AnswerGenVoteNotHelpful = 'summarized_answer_not_helpful',
  AnswerGenVoteHelpful = 'summarized_answer_helpful',
  AnswerGenNoHelpfulReason = 'summarized_answer_not_helpful_reason',
  ArticleVideoPlay = 'article_video_play',
  AnswerGenImageClick = 'summarized_answer_image_click',
  AnswerGenVideoClick = 'summarized_answer_video_click',
  KeraVoiceAssistantCta = 'kera_voice_assistant_cta',
  SupportRequestHyperlink = 'support_request_hyperlink',
  KeraVoiceAssistantAnnouncementApprove = 'kera_voice_assistant_announcement_approve',
  SearchSuggestedQuestionClicked = 'search_suggested_question',
}
